"use client"

import * as React from "react"
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, LabelList } from 'recharts';
import {
    Card, CardContent, CardHeader, CardTitle, CardDescription,
} from "src/@/components/ui/card"
import { ChartContainer } from "src/@/components/ui/chart"
import { Tooltip as ShadTooltip, TooltipContent as ShadTooltipContent, TooltipProvider, TooltipTrigger } from "src/@/components/ui/tooltip"
import { Info } from "lucide-react"
import EmptyContentGhost from "src/components/EmptyContentGhost"

const chartConfig = {
    taxa: { label: "Taxa %", color: "#8b5cf6" },
};

export function GraficoConversaoAgentes({ chartData = [] }) {
    return (
        <Card className="w-full">
            <CardHeader className="flex items-center gap-2 space-y-0 border-b border-gray-50 py-3 sm:flex-row">
                <div className="grid flex-1 gap-1 text-center sm:text-left">
                    <div className="flex items-center gap-1">
                        <CardTitle>Conversão por Agente</CardTitle>
                        <TooltipProvider>
                            <ShadTooltip>
                                <TooltipTrigger asChild>
                                    <Info className="w-3.5 h-3.5 text-gray-400 cursor-help" />
                                </TooltipTrigger>
                                <ShadTooltipContent side="top" className="max-w-xs text-xs">
                                    <p>Percentual de leads convertidos (ganhos) sobre o total de leads fechados por cada agente</p>
                                </ShadTooltipContent>
                            </ShadTooltip>
                        </TooltipProvider>
                    </div>
                    <CardDescription>Taxa de conversão de cada agente</CardDescription>
                </div>
            </CardHeader>
            <CardContent>
                {chartData.length === 0 ? (
                    <EmptyContentGhost />
                ) : (
                    <ChartContainer className="w-full h-[350px]" config={chartConfig}>
                        <BarChart data={chartData} layout="vertical" margin={{ top: 5, right: 40, left: 20, bottom: 5 }}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis type="number" domain={[0, 100]} unit="%" />
                            <YAxis dataKey="nome" type="category" width={100} tick={{ fontSize: 12 }} />
                            <Tooltip formatter={(value) => `${value}%`} />
                            <Bar dataKey="taxa" fill="#8b5cf6" barSize={20} radius={[0, 4, 4, 0]}>
                                <LabelList dataKey="taxa" position="right" formatter={(v) => `${v}%`} fontSize={12} />
                            </Bar>
                        </BarChart>
                    </ChartContainer>
                )}
            </CardContent>
        </Card>
    )
}
